import { Controller } from 'stimulus'

// On the job-column form: if any option "Merge into…" select is chosen,
// confirm before submitting — the merge rewrites stored values on jobs.
// Also drives the "similar to X" chips: one click sets the row's merge
// select to the suggested target, clicking again resets it to Keep.
export default class extends Controller {
  confirm(ev) {
    const chosen = Array.from(this.element.querySelectorAll('select[name^="mapping["]'))
      .filter(select => select.value)
    if (!chosen.length) return

    const message = `Apply ${chosen.length === 1 ? 'the selected merge' : `${chosen.length} selected merges`}? ` +
      'The stored value on every affected job will be updated.'
    if (!window.confirm(message)) ev.preventDefault()
  }

  acceptSimilar(ev) {
    const chip = ev.currentTarget
    const row = chip.closest('[data-option-row]')
    const select = row && row.querySelector('select[name^="mapping["]')
    if (!select) return

    const target = chip.dataset.targetValue
    select.value = select.value === target ? '' : target
    this.syncChip(chip, select)
  }

  syncRow(ev) {
    const row = ev.currentTarget.closest('[data-option-row]')
    const chip = row && row.querySelector('[data-target-value]')
    if (chip) this.syncChip(chip, ev.currentTarget)
  }

  syncChip(chip, select) {
    const target = chip.dataset.targetValue
    const merged = select.value === target
    chip.textContent = merged ? `merging into “${target}”` : `similar to “${target}”`
    chip.classList.toggle('text-yellow-800', !merged)
    chip.classList.toggle('bg-yellow-100', !merged)
    chip.classList.toggle('border-yellow-200', !merged)
    chip.classList.toggle('text-green-800', merged)
    chip.classList.toggle('bg-green-100', merged)
    chip.classList.toggle('border-green-200', merged)
  }
}
